import type { PropsWithChildren } from "react";
import { createPortal } from "react-dom";
import { useFloatingControlContext } from "./context";

/**
 * Put something into the app's one floating surface — the draggable shell that snaps to a corner
 * and can be pushed off the edge of the screen.
 *
 * The shell brings the handle and the dragging; the content brings its own look. Nothing is
 * rendered until the shell exists, so a panel mounted in the same commit as the provider waits one
 * render rather than landing loose at the end of the document.
 */
export function FloatingControlPanel({ children }: PropsWithChildren) {
	/** Context */
	const { container } = useFloatingControlContext();

	/** Guard */
	if (!container) return null;

	/** Render */
	return createPortal(children, container);
}
